<template>
    <!-- <van-pull-refresh v-model="isLoading"
                    @refresh="onRefresh"> -->
    <div class="container">
        <div class="type-card">
            <div class="card-item Activer txt"
                 @click="toPage(1)">常见问题</div>
            <div class="card-item poper"
                 @click="toPage(2)">
                <div class="more">人工通道</div>
                <div class="min">一对一服务</div>
            </div>

        </div>

        <div class="head">
            <h3> 请选择你遇到的问题分类</h3>
            <div class="line"></div>
        </div>

        <div class="box">
            <div class="quest-list"
                 v-if="list.length > 0">
                <van-list v-model="loading"
                          :immediate-check="false"
                          class="quest-ul"
                          :finished="finished"
                          finished-text="没有更多了"
                          @load="onLoad">
                    <van-cell v-for="item in list"
                              @click="goToQuest(item.value)"
                              class="quest-li"
                              :key="item.value"> <span> {{item.name}} </span> <img class="arrow"
                             src="../assets/images/arrow-r.svg"
                             alt=""> </van-cell>
                </van-list>

            </div>

        </div>

    </div>

    <!-- </van-pull-refresh> -->

</template>

<script>
import Vue from 'vue';
import http from '../utils/http.js';
import { countClick } from "../common/mixin"
import { Toast } from 'vant';
Vue.use(Toast);
export default {
    name: 'index',
    mixins: [countClick], // 混入 
    data () {
        return {
            loading: false,
            finished: false,
            count: 0,
            isLoading: false,
            msg: '问题分类',
            show: false,
            list: [], //  问题列表 
            sourceList: [],
            pageIndex: 0,
            index: 0,
        }
    },
    mounted () {
        // this.getData();
        this.clickEvent();
        this.getList();
        document.title = "刷机帮助";
    },
    methods: {
        toPage (v) {
            let name = '';
            if (v == 1) {
                name = 'index'
            } else if (v == 2) {
                name = 'service'
            } else {
                name = 'index'
            }
            this.$router.push({
                name: name
            })

        },

        group (array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, index += subGroupLength));
            }
            return newArray;
        },
        onLoad () {
            // setTimeout(() => {
            //   // let newList = this.group(this.sourceList, 10);
            //   let newList = this.sourceList;
            //   this.pageIndex++;
            //   if (this.pageIndex < newList.length) {
            //     this.list = this.list.concat(newList[this.pageIndex]);
            //     console.log(this.list);
            //     this.loading = false;
            //   } else {
            //     this.finished = true;
            //   }

            // }, 1000);
            this.finished = true;
        },
        onRefresh () {
            setTimeout(() => {
                Toast('刷新成功');
                this.isLoading = false;
                this.count++;
            }, 1000);
        },
        goToQuest (id) {
            this.$router.push('/quest/' + id);
        },
        getList () {

            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            var url = "/feedback/flashinghelp";
            var params = {};
            http.get(url, params).then(res => {
                this.$toast.clear();
                if (res.data.code == 0) {

                    let data = res.data.data;
                    this.sourceList = data;
                    if (data.length > 10) {
                        this.list = data;
                        // 首页不做截取 
                        // this.list = data.slice(0, 10);

                    } else {
                        this.list = data;
                    }
                } else {
                    this.$toast("暂无数据")
                }
            })

        },
        onshow () {
            this.show = true;
        },
        getData () {
            var url = "/abs/dataList";
            var id = "";
            var value = "";
            var params = {
                id: id,
                key: value
            }
            http.get(url, params).then(resp => {

            })
        },
        onChange (index) {
            this.index = index;
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped>
.box {
    position: relative;
    left: 0;
    border-radius: 12px 12px 0 0;
}
.container {
    position: relative;
    padding-top: 24px;
    top: 0;
    left: 0;
}
.container .type-card {
    width: 100%;
    height: 56px;
    border-radius: 6px;
    background: rgba(240, 240, 245, 1);
    margin-bottom: 24px;
    display: flex;
    align-items: center;
}
.card-item {
    width: 50%;
    height: 50px;
    border-radius: 6px;
    cursor: pointer;
}
.type-card .txt {
    font-size: 18px;
    color: #fff;
    font-weight: 600;
    text-align: center;
    line-height: 56px;
}
.poper {
    color: #4e5969;
    text-align: center;
}
.poper .more {
    padding-top: 6px;
    font-size: 18px;
}
.poper .min {
    font-size: 12px;
}

.Activer {
    background: rgba(22, 93, 255, 1);
}
.container .head {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background: url('../assets/images/bg1.png') top center no-repeat;
    background-size: 100% 140px;
}

.container .head .line {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 10px;
    background: #fff;
    border-radius: 12px 12px 0 0;
}
.container .head h3 {
    padding-top: 44px;
    padding-left: 16px;
    color: #fff;
    font-size: 22px;
    font-weight: 500;
    text-align: left;
}
.quest-list {
    width: 100%;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
}
.quest-list .quest-ul {
    padding: 0 16px;
}
.quest-list .quest-ul .quest-li {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    list-style: none;
    text-align: left;
    font-size: 16px;
    color: #333;
}
.quest-list .quest-ul .quest-li:nth-child(1) {
    height: 48px;
    line-height: 48px;
}
.quest-list .quest-ul .quest-li::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 106%;
    height: 1px;
    background-color: #e6e6e6;
    opacity: 0.7;
}
.quest-list .quest-ul .quest-li span {
    display: inline-block;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.quest-list .quest-ul .quest-li .arrow {
    /* vertical-align: text-bottom; */
    float: right;
    padding-top: 22px;
}
.quest-ul >>> .van-cell {
    padding: 0;
    cursor: pointer;
}
.quest-ul >>> .van-cell::after {
    transform: scaleY(1);
    border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue